(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dl-mobile-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dl-mobile-chat')) {
  customElements.define('dl-mobile-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.running) return;
      this.running = true;
      this.openButton = this.querySelector('[data-chat-open]');
      this.retryButton = this.querySelector('[data-chat-retry]');
      this.emailLink = this.querySelector('[data-chat-email]');
      this.status = this.querySelector('[data-chat-status]');
      this.onOpen = (event) => { event.stopPropagation(); this.openChat(); };
      this.onRetry = (event) => {
        event.stopPropagation();
        this.failedTrigger = null;
        this.deadline = Date.now() + 12000;
        this.setState('loading');
        this.status.focus({ preventScroll: true });
        this.sync();
        if (this.state === 'ready') this.openChat();
      };
      this.openButton.addEventListener('click', this.onOpen);
      this.retryButton.addEventListener('click', this.onRetry);
      this.deadline = Date.now() + 12000;
      this.setState('loading');
      this.sync();
      this.timer = setInterval(() => this.sync(), 500);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.openTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.activationTimer);
      this.observer?.disconnect();
      this.openButton?.removeEventListener('click', this.onOpen);
      this.retryButton?.removeEventListener('click', this.onRetry);
      this.trigger = null;
      this.openedByUs = false;
      this.running = false;
    }
    setState(state) {
      if (this.state === state) return;
      const hadControlFocus = this.contains(document.activeElement);
      const previousState = this.state;
      this.state = state;
      this.dataset.chatState = state;
      this.openButton.disabled = state !== 'ready' && state !== 'opening';
      this.openButton.setAttribute('aria-busy', String(state === 'loading' || state === 'opening'));
      this.status.textContent = state === 'ready' ? '' : this.dataset[state];
      this.retryButton.hidden = state !== 'unavailable';
      this.emailLink.hidden = state !== 'unavailable';
      if (state === 'ready' && previousState !== 'opening' && hadControlFocus) this.openButton.focus({ preventScroll: true });
    }
    sync() {
      const root = document.querySelector('shopify-chat')?.shadowRoot
        ?.querySelector('shopify-agent-runtime')?.shadowRoot;
      const trigger = root?.querySelector('button[part~="activator"]');
      if (trigger !== this.trigger) {
        this.observer?.disconnect();
        const lostOpenAttempt = this.state === 'opening' || this.openedByUs;
        clearTimeout(this.openTimer);
        this.trigger = trigger;
        this.root = root;
        this.wasOpen = false;
        this.openedByUs = false;
        this.openButton.setAttribute('aria-expanded', 'false');
        this.deadline = Date.now() + 12000;
        if (trigger) {
          this.observer = new MutationObserver(() => this.readPanel());
          this.observer.observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
          this.setState('ready');
          if (lostOpenAttempt && !this.contains(document.activeElement)) this.openButton.focus({ preventScroll: true });
        } else this.setState('loading');
      }
      if (!trigger) {
        if (Date.now() >= this.deadline) this.setState('unavailable');
        return;
      }
      if (this.state === 'loading' && this.failedTrigger !== trigger) this.setState('ready');
      this.readPanel();
    }
    readPanel() {
      if (!this.trigger) return;
      const open = this.trigger.getAttribute('aria-expanded') === 'true';
      this.openButton.setAttribute('aria-expanded', String(open));
      if (open && this.openedByUs && !this.wasOpen) {
        clearTimeout(this.openTimer);
        this.setState('ready');
        const panel = this.root.querySelector('[part~="dialog"]');
        this.focusTimer = setTimeout(() => {
          if (this.isConnected && this.openedByUs && this.trigger?.getAttribute('aria-expanded') === 'true' && panel && !panel.contains(this.root.activeElement)) panel.focus({ preventScroll: true });
        }, 100);
      }
      if (!open && this.wasOpen && this.openedByUs) {
        this.openedByUs = false;
        this.setState('ready');
        if (this.isConnected) this.openButton.focus({ preventScroll: true });
      }
      this.wasOpen = open;
    }
    openChat() {
      this.sync();
      if (!this.trigger || this.state !== 'ready') return;
      this.openedByUs = true;
      this.wasOpen = false;
      this.setState('opening');
      this.activationTimer = setTimeout(() => {
        try {
          this.trigger.click();
          this.readPanel();
          if (this.state === 'opening') this.openTimer = setTimeout(() => this.fail(), 6000);
        } catch { this.fail(); }
      }, 0);
    }
    fail() {
      this.failedTrigger = this.trigger;
      this.openedByUs = false;
      this.setState('unavailable');
      if (this.isConnected) this.retryButton.focus({ preventScroll: true });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dl-product-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('dl-product-experience');
  if (!marker || marker.dataset.initialized) return;
  marker.dataset.initialized = 'true';
  const content = {
    '10503151747361': {
      label: 'Name or wording for your name plate',
      instructions: 'Enter the exact wording to print. Please check spelling, capitalization, and punctuation before ordering.'
    },
    '10505169207585': {
      label: 'Your five divider-tab labels',
      instructions: 'Enter five category names, one per line, in your preferred order. Please check spelling and capitalization.',
      example: 'Example: Bills / Savings / Expenses / Income / Challenges'
    },
    '9906594283809': {
      label: 'Your six category labels',
      instructions: 'Enter six category names, one per line, in your preferred order. Your labels will be used on both the bookmark inserts and the envelopes. Please check spelling and capitalization. Select your acrylic color separately above.'
    }
  }[marker.dataset.productId];
  const main = document.querySelector('main');
  if (content && main) {
    let currentInput = null;
    let savedValue = '';
    let captured = false;
    let restoring = false;
    const apply = () => {
      const input = main.querySelector('textarea[id^="tcustomizer-form-field-627750-"]');
      const wrapper = input?.closest('.tcustomizer-field');
      const label = wrapper?.querySelector('label.tcustomizer-field__heading');
      if (!input || !wrapper || !label) return;
      const changedInput = currentInput && currentInput !== input;
      currentInput = input;
      const text = label.querySelector('span') || label;
      if (text.textContent !== content.label) text.textContent = content.label;
      if (label.htmlFor !== input.id) label.htmlFor = input.id;
      const helpId = 'dl-product-help-' + marker.dataset.productId;
      let help = wrapper.querySelector('#' + helpId);
      if (!help) {
        help = document.createElement('p');
        help.id = helpId;
        help.className = 'dl-product-field-help';
        help.textContent = content.instructions;
        if (content.example) {
          const example = document.createElement('span');
          example.className = 'dl-product-field-example';
          example.textContent = content.example;
          help.append(example);
        }
        label.after(help);
      }
      const described = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      if (!described.has(helpId)) {
        described.add(helpId);
        input.setAttribute('aria-describedby', [...described].join(' '));
      }
      if (changedInput && captured && input.value !== savedValue) {
        restoring = true;
        input.value = savedValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        restoring = false;
      } else if (!captured && input.value) {
        savedValue = input.value;
        captured = true;
      }
    };
    main.addEventListener('input', event => {
      if (!restoring && event.target === currentInput) {
        savedValue = currentInput.value;
        captured = true;
      }
    }, true);
    new MutationObserver(apply).observe(main, { childList: true, subtree: true });
    apply();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
